<template>
  <teleport to="#overlay">
    <div class="overlay w100 h100 abs">
      <div class="overlay-panel rel pb24">
        <form
          class="flex-container flex-col min-height-inherit"
          id="panel"
          @submit.prevent="onSubmit"
        >
          <div class="panel-header p24">
            <div class="mini-logo"></div>
            <h2 class="panel-title nomargin bebas">Genera Contenuto</h2>
          </div>

          <keep-alive>
            <div
              v-if="data.step === 0"
              class="flex-container flex-col pl24 pr24 pb24"
            >
              <textarea
                class="flex-container flex-col add-description pb16"
                :value="data.description || ''"
                @input="onDescriptionInput"
                placeholder="inserisci una breve descrizione"
              ></textarea>

              <div class="flex-container flex-col">
                <AjaxSearchSelect
                  :config="{
                    mode: 'tags',
                    trackBy: 'name',
                    label: 'name',
                    valueProp: 'name',
                  }"
                  :feedUrl="ApiEndPoints.TAGS"
                  @select="onTagSelect"
                  @deselect="onTagDeSelect"
                  :selected="data.selectedTags"
                  label="selezionare i target"
                  :className="'flex-container flex-col mb8 pl8 no-grow'"
                >
                </AjaxSearchSelect>
              </div>
            </div>
          </keep-alive>

          <keep-alive>
            <div
              v-if="data.step === 1"
              class="flex-container flex-row pl24 pr24 pb24"
            >
              <!-- Gender selection -->
              <div class="flex-container flex-col flex-grow">
                <label>Genere:</label>
                <div
                  class="flex-container flex-row flex-wrap overflow-auto innovativestudio_contenitore_sesso"
                >
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="all-genders"
                      value="all"
                      v-model="data.gender"
                      @change="onAllGendersChange"
                    />
                    <label for="all-genders">Tutti i generi</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="female"
                      value="f"
                      v-model="data.gender"
                      :disabled="allGendersSelected"
                    />
                    <label for="female">Donne</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="male"
                      value="m"
                      v-model="data.gender"
                      :disabled="allGendersSelected"
                    />
                    <label for="male">Uomini</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="other"
                      value="u"
                      v-model="data.gender"
                      :disabled="allGendersSelected"
                    />
                    <label for="other">Altro</label>
                  </div>
                </div>
              </div>

              <!-- Age selection -->
              <div class="flex-container flex-col flex-grow">
                <label>Età:</label>
                <div
                  class="flex-container flex-row flex-wrap overflow-auto innovativestudio_contenitore_eta"
                >
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="all-ages"
                      value="all"
                      v-model="data.age"
                      @change="onAllAgesChange"
                    />
                    <label for="all-ages">Tutte le età</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="18-24"
                      value="18-24"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />

                    <label for="18-24">18-24</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="25-34"
                      value="25-34"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />
                    <label for="25-34">25-34</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="35-44"
                      value="35-44"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />
                    <label for="35-44">35-44</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="45-54"
                      value="45-54"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />
                    <label for="45-54">45-54</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="55-64"
                      value="55-64"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />
                    <label for="55-64">55-64</label>
                  </div>
                  <div class="flex-container flex-row align-center ns pnt">
                    <input
                      type="checkbox"
                      id="65"
                      value="65"
                      v-model="data.age"
                      :disabled="allAgesSelected"
                    />
                    <label for="65">65+</label>
                  </div>
                </div>
              </div>
            </div>
          </keep-alive>

          <keep-alive>
            <div
              v-if="data.step === 2"
              class="flex-container flex-row pl24 pr24 pb24"
              id="cody-response-container"
            >
              <div
                v-if="data.isLoading"
                class="flex-container flex-end-align spinner-container"
              >
                <Spinner id="spinner" />
              </div>
              <div v-else id="cody_response_container_list">
                <div v-if="data.codyResponses && data.codyResponses.length > 0">
                  <div
                    v-for="(response, index) in data.codyResponses"
                    :key="index"
                    :class="{ 'ai-selected': index === data.selectedIndex }"
                  >
                    <!-- Aggiungi questa riga -->
                    <div
                      v-if="!response.error"
                      class="innovativestudio_codyresponse_element"
                    >
                      <h6>Origine: {{ response.socialName }}</h6>
                      <p>
                        {{ response.content }}
                      </p>
                      <input
                        type="button"
                        @click="selectResponse(response, index)"
                        value="Seleziona"
                      />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <p>Nessun dato disponibile</p>
                </div>
              </div>
            </div>
          </keep-alive>

          <div class="flex-container panel-footer abs w100">
            <div class="flex-container">
              <input
                type="reset"
                :value="data.step === 0 ? 'annulla' : 'indietro'"
                class="w100 noborder nopadding bebas"
                @click.prevent="prev"
              />
              <input
                type="submit"
                :value="nextButtonText"
                class="w100 noborder nopadding bebas"
                :disabled="preventNext"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </teleport>
</template>
<script>
import { computed, reactive, ref, inject } from "vue";
import { useStore } from "vuex";
//import { useRouter } from "vue-router";
import { ApiEndPoints } from "@/api/Endpoints";
import AjaxSearchSelect from "@/components/formelements/AjaxSearchSelect";
import axios from "axios";
import Spinner from "@/components/Spinner.vue";
import qs from "qs";

export default {
  props: ["AiData"],
  methods: {
    selectResponse(response, index) {
      this.data.selectedResponse = response;
      this.data.selectedIndex = index;
    },
  },
  emits: ["close", "response-selected", "aidata-updated"],
  components: {
    /* MultiTag, */
    AjaxSearchSelect,
    Spinner,
  },
  setup(props, { emit }) {
    const store = useStore();
    //const router = useRouter();
    const me = inject("me");
    const type = ref(null);
    const allGendersSelected = computed(() => data.gender.includes("all"));
    const allAgesSelected = computed(() => data.age?.includes("all"));

    const startCal = ref(null);

    let UseAiData =
      props.AiData?.step ||
      (0 >= 2 && props.AiData?.codyResponses.length) ||
      [].length > 0;
    const data = reactive({
      step: UseAiData ? props.AiData.step : 0,
      type: UseAiData ? props.AiData.type : null,
      description: UseAiData ? props.AiData.description : null,
      selectedTags: UseAiData ? props.AiData.selectedTags : [],
      gender: UseAiData ? props.AiData.gender : [],
      age: UseAiData ? props.AiData.age : [],
      selectedResponse: UseAiData ? props.AiData.selectedResponse : null,
      selectedIndex: UseAiData ? props.AiData.selectedIndex : null,
      codyResponses: UseAiData ? props.AiData.codyResponses : [],
      isLoading: false,
    });

    const onAllGendersChange = () => {
      if (allGendersSelected.value) {
        data.gender = ["all"];
      }
    };

    const onAllAgesChange = () => {
      if (allAgesSelected.value) {
        data.age = ["all"];
      }
    };

    const preventNext = computed(() => {
      if (
        data.step === 0 &&
        data?.selectedTags?.length > 0 &&
        data.description?.length > 0
      ) {
        return false;
      }
      if (data.step === 1 && data.gender.length > 0 && data.age.length > 0) {
        return false;
      }
      if (data.step === 2 && data.selectedResponse) {
        return false;
      }

      return true;
    });

    const nextButtonText = computed(() =>
      data.step === 2 ? "conferma" : "avanti"
    );

    const next = () => {
      data.step++;
      if (data.step === 2) {
        GenerateContent();
      }
    };
    const prev = () => {
      if (data.step === 0) {
        emit("close");
      } else {
        data.step--;
      }
    };

    const allTags = computed(() => store.getters["tags/tags"]);

    const onTagSelect = (tag) => {
      const index = data.selectedTags.indexOf(tag);
      if (index === -1) {
        data.selectedTags.push(tag);
      }
    };
    const onTagDeSelect = (tag) => {
      const index = data.selectedTags.indexOf(tag);
      if (index !== -1) {
        data.selectedTags.splice(index, 1);
      }
    };

    const onDescriptionInput = (e) => {
      data.description = e.target.value;
    };

    const onSubmit = async () => {
      if (data.step === 2) {
        confirm();
      } else {
        next();
      }
    };

    const GetValidSocials = async () => {
      let tags = data.selectedTags.map((tag) => tag.id);
      return await axios.get(ApiEndPoints.SOCIAL + "/by", {
        params: {
          tag: tags,
          gender: data.gender,
          age: data.age,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "repeat" }),
      });
    };

    const GetCodyResponses = async (validSocials) => {
      let promises = validSocials.map((social) =>
        axios.post(ApiEndPoints.AI + "/createcontent", {
          socialName: social.socialName,
          description: data.description,
          maxLen: 349,
        })
      );

      // Esegui tutte le promesse
      let codyResponses = await Promise.all(promises);

      // Ora "codyResponses" contiene le risposte di tutte le chiamate API a Cody
      return codyResponses.map((res) => {
        if (res instanceof Error) {
          // Gestisci l'errore qui. Potresti voler restituire un oggetto di errore personalizzato o semplicemente la stringa di errore.
          return { error: true, message: res.message };
        } else {
          // Se non c'è errore, restituisci i dati
          res.data.error = false;
          return res.data;
        }
      });
    };

    const GenerateContent = async () => {
      // reset
      data.selectedResponse = null;
      data.selectedIndex = null;
      // restart query
      data.isLoading = true;
      try {
        // Chiamata al backend
        const validSocials = await GetValidSocials();
        let amount = 4; // Quantità di social massimi da esporre (in ordine di rating)
        let topSocials = validSocials.data.slice(0, amount);

        const codyResponses = await GetCodyResponses(topSocials);
        data.codyResponses = codyResponses;
      } catch (error) {
        console.error(error);
      } finally {
        data.isLoading = false;
      }
    };

    const confirm = () => {
      if (data.selectedResponse !== null) {
        // Crea una copia dei nuovi dati da inviare
        const newData = { ...data };
        newData.step = 2;

        // Emetto l'evento con i nuovi dati generati al padre
        emit("aidata-updated", newData);

        // Restituisci il testo selezionato al componente padre
        //this.$emit("response-selected", data.selectedResponse);
        emit("response-selected", data.selectedResponse); // invia il messaggio al componente padre
        emit("close");
      }
    };

    return {
      me,
      allTags,
      emit,
      onSubmit,
      //selectedTags,
      onTagSelect,
      onTagDeSelect,
      preventNext,
      next,
      prev,
      data,
      type,
      nextButtonText,
      onDescriptionInput,
      startCal,
      ApiEndPoints,
      allGendersSelected,
      allAgesSelected,
      onAllGendersChange,
      onAllAgesChange,
    };
  },
};
</script>

<style lang="postcss">
.flex-container {
  display: flex;
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-grow {
  flex-grow: 1;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-center {
  align-items: center;
}

.overflow-auto {
  overflow: auto;
}

.ai-selected {
  background: #fffbe0;
}
</style>
